export const TRIP_TYPES = ["One-way", "Round-trip", "Hourly", "Airport"] as const;
export type TripType = (typeof TRIP_TYPES)[number];

export const VEHICLE_OPTIONS = [
  { key: "STANDARD SEDAN", label: "Standard Sedan" },
  { key: "LUXURY SEDAN", label: "Luxury Sedan" },
  { key: "MINI SUV", label: "Mini SUV" },
  { key: "FULL SUV", label: "Full SUV" },
  { key: "PREMIUM SUV", label: "Premium SUV" },
  { key: "SPRINTER", label: "Mercedes Sprinter" },
  { key: "OTHER / VEHICLE TO BE CONFIRMED", label: "Not sure yet" },
] as const;

export const LUGGAGE_OPTIONS = ["0", "1", "2", "3", "4", "5+"];
export const STOP_OPTIONS = ["0", "1", "2", "3+"];
export const HOURLY_OPTIONS = ["3 hours", "4 hours", "6 hours", "8 hours", "10 hours"];

export const SERVICE_OPTIONS = [
  "Airport Transfer",
  "Corporate Travel",
  "Wedding Transportation",
  "Prom / Formal Event",
  "Cruise Transfer",
  "Point-to-Point",
  "Other / Special Request",
];

export interface QuotePrefill {
  tripType?: string;
  pickup?: string;
  dropoff?: string;
  date?: string;
  time?: string;
  passengers?: string;
  vehicle?: string;
}

export function buildTripNotes(input: {
  tripType: string;
  returnDate?: string;
  returnTime?: string;
  hours?: string;
  flight?: string;
  luggage?: string;
  stops?: string;
  meetGreet?: boolean;
  notes?: string;
}): string {
  const lines = [`Trip type: ${input.tripType}`];
  if (input.tripType === "Round-trip" && (input.returnDate || input.returnTime)) {
    lines.push(`Return: ${input.returnDate || "date TBC"} ${input.returnTime || ""}`.trim());
  }
  if (input.tripType === "Hourly" && input.hours) lines.push(`Duration: ${input.hours}`);
  if (input.tripType === "Airport") {
    lines.push(`Meet & greet inside terminal: ${input.meetGreet ? "requested" : "not requested"}`);
  }
  if (input.flight) lines.push(`Flight number: ${input.flight}`);
  if (input.luggage) lines.push(`Luggage: ${input.luggage}`);
  if (input.stops) lines.push(`Extra stops: ${input.stops}`);
  if (input.notes) lines.push(input.notes);
  return lines.join("\n");
}
